import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import StepByStep from '../StepByStep/StepByStep';
import { getApplication } from '../../store/actions/application/applicationActions';
import useApplicationUid from '../../hooks/useApplicationUid';
import FundRetirementAmountForm from '../Forms/FundRetirementAmountForm';
import Custodian from '../Custodian/Custodian';
import CustodianAccountNumber from '../Custodian/CustodianAccountNumber';
import CustodianTransferType from '../Custodian/CustodianTransferType';
import CustodianIraType from '../Custodian/CustodianIraType';
import CustodianReview from '../Custodian/CustodianReview';
import Modal from '../Modal';

const steps = [
  Custodian,
  CustodianAccountNumber,
  CustodianTransferType,
  CustodianIraType,
  FundRetirementAmountForm,
  CustodianReview,
];

const CustodianModal = ({ isOpen, onClose, onSuccess }) => {
  const { ApplicationUid } = useApplicationUid();
  const [isManual, setIsManual] = useState(false);
  const [shouldClearForm, setShouldClearForm] = useState(false);
  const dispatch = useDispatch();

  return (
    <Modal variant="lg" isOpen={isOpen} onClose={onClose}>
      <StepByStep saveStepDisabled>
        {({ goStepForward, goStepBack, goToStepsBack }) =>
          steps.map((step) =>
            React.createElement(step, {
              handleBack: goStepBack,
              goToStepsBack,
              handleNext: () => {
                dispatch(getApplication({ data: { ApplicationUid } }));
                goStepForward();
              },
              onModalClose: () => {
                onClose();
                onSuccess();
              },
              setShouldClearForm,
              shouldClearForm,
              setIsManual,
              isManual,
            }),
          )
        }
      </StepByStep>
    </Modal>
  );
};

CustodianModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};

export default CustodianModal;
